<script>
import { mapGetters } from "vuex";
import AuthenticatedProfileImage from "./AuthenticatedProfileImage.vue";

export default {
  name: "UserBioCard",
  components: { AuthenticatedProfileImage },
  props: {
    showEditButton: { type: Boolean, default: false },
    minHeight: { type: String, default: "400px" },
  },
  computed: {
    ...mapGetters(["getUser", "getApplication", "getStudent"]),
    offering() {
      return (
        this.getStudent?.currentEnrollmentId?.programOfferingId ||
        this.getStudent?.initialProgramOfferingId ||
        this.getApplication?.programOfferingId ||
        {}
      );
    },
    displayNumber() {
      return (
        this.getStudent?.matriculationNumber ||
        this.getApplication?.applicationNumber ||
        "N/A"
      );
    },
    fullName() {
      return [
        this.getUser?.firstName,
        this.getUser?.otherName,
        this.getUser?.lastName,
      ]
        .filter(Boolean)
        .join(" ");
    },
    bioDetails() {
      return [
        {
          label: this.getStudent ? "Matriculation No" : "Application No",
          value: this.displayNumber,
        },
        { label: "Programme", value: this.offering?.program?.name || "N/A" },
        {
          label: "Department",
          value: this.offering?.department?.name || "N/A",
        },
        {
          label: "School",
          value: this.offering?.department?.school?.name || "N/A",
        },
        { label: "Email", value: this.getUser?.email || "N/A" },
        { label: "Phone", value: this.getUser?.phone || "N/A" },
        {
          label: "Date of Birth",
          value: this.formatDate(this.getUser?.dateOfBirth),
        },
      ];
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return "N/A";
      const date = new Date(value);
      return Number.isNaN(date.getTime())
        ? "N/A"
        : date.toLocaleDateString("en-GB");
    },
  },
};
</script>

<template>
  <div class="card border-0 shadow-sm" :style="{ minHeight }">
    <div
      class="card-header bg-white border-bottom-0 text-end text-secondary"
      style="font-size: small"
    >
      <span v-if="showEditButton">Edit</span>
    </div>
    <div class="card-img-top d-flex justify-content-center">
      <AuthenticatedProfileImage
        class="rounded-circle border border-2"
        :class="getStudent ? 'border-primary' : 'border-dark-subtle'"
        :size="100"
        alt="User profile image"
      />
    </div>
    <div class="card-body">
      <h6 class="text-center text-capitalize" style="font-weight: 550">
        {{ fullName || "User" }}
      </h6>

      <div class="my-3" style="font-size: 12px">
        <div v-for="item in bioDetails" :key="item.label" class="row mb-2">
          <div class="col-5 text-end fw-bold pe-0 text-secondary">
            {{ item.label }}
          </div>
          <div class="col-7 text-start">
            {{ item.value }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
